import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { isProfilingEnabled } from '@src/app/core/utils/feature-flags.util';
import { AuthSelectors } from '@src/app/store/auth/auth.selectors';
import { combineLatest, filter, map, take } from 'rxjs';

/**
 * Guard que protege rutas exclusivas para usuarios con perfil Poseedor Final
 * redirigiendo a /home (en lugar de /services) cuando el acceso no está permitido.
 *
 * Comportamiento:
 * - Si VIEW_PF=false: redirige a /home.
 * - Si VIEW_PF=true: espera a que selectedCompany esté cargado y comprueba selectIsPoseedorFinal.
 *   - true  → permite acceso
 *   - false → redirige a /home
 *
 * Aplica a /waste-data-management (PBI-858960).
 * No modifica poseedorFinalGuard para no afectar rutas existentes (/services/waste-consulting, etc.).
 */
export const poseedorFinalHomeGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (!isProfilingEnabled()) {
    return router.createUrlTree(['/home']);
  }

  const store = inject(Store);

  return combineLatest([
    store.select(AuthSelectors.selectSelectedCompany),
    store.select(AuthSelectors.selectIsPoseedorFinal),
  ]).pipe(
    filter(([company]) => !!company?.TIPO_TERCERO),
    take(1),
    map(([, isPF]) => {
      if (isPF) {
        return true;
      }
      return router.createUrlTree(['/home']);
    }),
  );
};
